import React, { useRef, useState } from 'react';
import {
  makeStyles,
  Typography,
  Grid,
  Box,
  IconButton,
  Dialog,
  useMediaQuery,
  useTheme,
} from '@material-ui/core';
import SwiperCore, { Navigation, Thumbs } from 'swiper';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/swiper-bundle.min.css';
import ArrowBackIosIcon from '@material-ui/icons/ArrowBackIos';
import ArrowForwardIosIcon from '@material-ui/icons/ArrowForwardIos';
import CloseIcon from '@material-ui/icons/Close';

SwiperCore.use([Navigation, Thumbs]);

const useStyles = makeStyles((theme) => ({
  mainBox: {
    marginBottom: 24,
    '& h5': {
      fontWeight: 700,
    },
  },
  subtitle: {
    color: '#919EAB',
  },
  thumbnail: {
    width: '100%',
    height: 170.25,
    objectFit: 'cover',
    borderRadius: 12,
    cursor: 'pointer',
    [theme.breakpoints.down('sm')]: {
      height: 100,
    },
  },
  dialogImage: {
    width: '432px',
    height: '432px',
    objectFit: 'contain',
    borderRadius: 12,
    margin: '0 auto',
    [theme.breakpoints.down('xs')]: {
      height: '40vh',
    },
  },
  dialogPaper: {
    borderRadius: 12,
    padding: 12,
    width: 432,
    maxWidth: '900px',
    margin: 'auto',
    [theme.breakpoints.down('xs')]: {
      padding: 8,
    },
  },
  thumbSwiper: {
    marginTop: theme.spacing(2),
    paddingBottom: theme.spacing(1),
    '& .swiper-slide': {
      opacity: 0.5,
    },
    '& .swiper-slide-thumb-active': {
      opacity: 1,
    },
  },
  thumbImage: {
    width: 64,
    height: 64,
    objectFit: 'cover',
    borderRadius: 12,
    cursor: 'pointer',
  },
}));

const UnifiedCustomerDetails = ({ vehicle, customer_note, photo_filenames }) => {
  const classes = useStyles();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  const swiperRef = useRef(null);
  const popupMainRef = useRef(null);
  const [thumbsSwiper, setThumbsSwiper] = useState(null);

  const [dialogOpen, setDialogOpen] = useState(false);
  const [dialogIndex, setDialogIndex] = useState(0);

  let folderName = 'stage-appointment-images/';
  if (process.env.REACT_APP_DATA_PROVIDER === 'prod') {
    folderName = 'appointment-images/';
  }

  const goPrev = () => {
    if (swiperRef.current) swiperRef.current.slidePrev();
  };
  const goNext = () => {
    if (swiperRef.current) swiperRef.current.slideNext();
  };

  const openDialog = (index) => {
    setDialogIndex(index);
    setDialogOpen(true);
  };

  return (
    <>
      <Grid container spacing={0}>
        {customer_note && (
          <Grid item xs={12} sm={12} md={12}>
            <Box display="flex" alignItems="center" flexWrap="wrap">
              <Box mr={2} className={classes.mainBox}>
                <Typography variant="h5" gutterBottom>
                  Customer Notes
                </Typography>
                <Typography variant="body2" className={classes.subtitle}>
                  {customer_note}
                </Typography>
              </Box>
            </Box>
          </Grid>
        )}
        {/*  <Grid item xs={2} sm={2} md={2} className={classes.textRight}>
            <EditIcon
                fontSize="inherit"
                className={classes.pointIcon}
                onClick={() => setIsEditing((prev) => !prev)}
            />
            </Grid> */}
      </Grid>
      {photo_filenames && photo_filenames.length > 0 && (
        <>
          <Grid container spacing={0}>
            <Box display="flex" alignItems="center" flexWrap="wrap">
              <Box mr={2} className={classes.mainBox}>
                <Typography variant="h5" gutterBottom>
                  Customer Images
                </Typography>
                <Typography variant="body2" className={classes.subtitle}>
                  {photo_filenames.length} images
                </Typography>
              </Box>
            </Box>
          </Grid>
          <Grid container spacing={0}>
            <Grid item xs={12} style={{ position: 'relative' }}>
              <Swiper
                onSwiper={(swiper) => (swiperRef.current = swiper)}
                spaceBetween={24}
                slidesPerView={isMobile ? 1 : 4}
                navigation={false}
              >
                {photo_filenames.map((img, idx) => (
                  <SwiperSlide key={idx}>
                    {/* eslint-disable-next-line jsx-a11y/click-events-have-key-events */}
                    <img
                      onClick={() => openDialog(idx)}
                      src={`${process.env.REACT_APP_AWS_FILE_URL}${folderName}${img}`}
                      alt={`Appointment Image ${idx}`}
                      className={classes.thumbnail}
                    />
                  </SwiperSlide>
                ))}
              </Swiper>
              {/* Custom Left Arrow */}
              <IconButton
                onClick={goPrev}
                size="small"
                style={{
                  position: 'absolute',
                  top: '-22%',
                  right: 5,
                  transform: 'translate(-50%, -50%)',
                  zIndex: 10,
                }}
                aria-label="Previous"
              >
                <ArrowBackIosIcon
                  style={{
                    fontSize: '20',
                  }}
                />
              </IconButton>

              {/* Custom Right Arrow */}
              <IconButton
                onClick={goNext}
                size="small"
                style={{
                  position: 'absolute',
                  top: '-22%',
                  right: 10,
                  transform: 'translate(50%, -50%)',
                  zIndex: 10,
                }}
                aria-label="Next"
              >
                <ArrowForwardIosIcon
                  style={{
                    fontSize: '20',
                  }}
                />
              </IconButton>
            </Grid>
          </Grid>
          {/* DIALOG */}
          <Dialog
            open={dialogOpen}
            onClose={() => {
              setDialogOpen(false);
              setDialogIndex(0);
              setThumbsSwiper(null); // reset thumbnail swiper on close
            }}
            maxWidth="xs"
            classes={{ paper: classes.dialogPaper }}
          >
            <Box
              display="flex"
              justifyContent="space-between"
              alignItems="center"
              p={1}
            >
              <Typography variant="h6">Customer images</Typography>
              <IconButton
                onClick={() => {
                  setDialogOpen(false);
                  setDialogIndex(0);
                  setThumbsSwiper(null); // reset thumbnail swiper on close
                }}
              >
                <CloseIcon />
              </IconButton>
            </Box>
            <Grid container spacing={0}>
              <Grid item xs={12} style={{ position: 'relative' }}>
                <Swiper
                  onSwiper={(swiper) => {
                    popupMainRef.current = swiper;
                    swiper.slideToLoop(dialogIndex);
                  }}
                  loop
                  thumbs={{ swiper: thumbsSwiper }}
                >
                  {photo_filenames.map((img, idx) => (
                    <SwiperSlide key={idx}>
                      {/* eslint-disable-next-line jsx-a11y/img-redundant-alt */}
                      <img
                        src={`${process.env.REACT_APP_AWS_FILE_URL}${folderName}${img}`}
                        alt={`Appointment Image ${idx}`}
                        className={classes.dialogImage}
                      />
                    </SwiperSlide>
                  ))}
                </Swiper>
                {/* Thumbnail Swiper */}
                <Swiper
                  onSwiper={setThumbsSwiper}
                  spaceBetween={16}
                  slidesPerView={isMobile ? 5 : 5}
                  watchSlidesVisibility
                  watchSlidesProgress
                  className={classes.thumbSwiper}
                >
                  {photo_filenames.map((img, idx) => (
                    <SwiperSlide key={idx}>
                      {/* eslint-disable-next-line jsx-a11y/img-redundant-alt */}
                      <img
                        src={`${process.env.REACT_APP_AWS_FILE_URL}${folderName}${img}`}
                        alt={`Appointment Image ${idx}`}
                        className={classes.thumbImage}
                      />
                    </SwiperSlide>
                  ))}
                </Swiper>
              </Grid>
            </Grid>
          </Dialog>{' '}
        </>
      )}
    </>
  );
};

export default UnifiedCustomerDetails;
